module.exports = __webpack_public_path__ + "img/HEDIScale.fc77689d.png";